// https://web.dev/external-anchors-use-rel-noopener/
// Can also be done with DOMPurify https://github.com/cure53/DOMPurify/issues/317#issuecomment-698800327
import { mapValuesDeep } from "../map-values-deep";

export const withReferrerPolicy = <T>(replyParsed: T): T => {
    return mapValuesDeep(replyParsed, (value: any) => {
        if (value && typeof value === "object" && "text"in value) {
            return {...value, text: addRelAttribute(value.text)};
        }
        return typeof value === "string" ? addRelAttribute(value) : value;
    });
};

export const addRelAttribute = (text: string): string => {
    // Füge rel nur hinzu, wenn es noch nicht existiert
    return text.replace(/<a\b([^>]*)>/gi, (match, attrs) => {
        if (/rel\s*=\s*["']?noopener noreferrer["']?/i.test(attrs)) {
            return match; // rel existiert bereits
        }
        return `<a${attrs} rel="noopener noreferrer">`;
    });
};
